import { useRef } from "react";
import { HiUserCircle } from "react-icons/hi";

import { useMenu } from "hooks";
import { tw } from "utils/tw";

import { MenuList } from ".";
import useAccountMenuItems from "./useAccountMenuItems";

export default (): React.JSX.Element => {
  const accountsMenuRef = useRef<HTMLDivElement>(null);
  const [isShowingAccountsMenu, setIsShowingAccountsMenu] =
    useMenu(accountsMenuRef);
  const toggleAccountsMenu = () =>
    setIsShowingAccountsMenu(!isShowingAccountsMenu);

  const accountMenuItems = useAccountMenuItems({});

  const accountsMenuStyles = tw(
    "origin-top-right",
    "absolute",
    "right-0",
    "mt-2",
    "w-80",
    "rounded-md",
    "shadow-lg",
    "bg-white",
    "ring-1",
    "ring-gray-900",
    "ring-opacity-5",
    "focus:outline-none"
  );

  return (
    <div className={tw("relative")} ref={accountsMenuRef}>
      <button
        aria-label="accounts menu"
        aria-expanded={isShowingAccountsMenu}
        onClick={toggleAccountsMenu}
        className={tw("p-2", "bg-deepBlue-50", "rounded-full")}
      >
        <HiUserCircle size="22px" className={tw("text-gray-900")} />
      </button>

      {isShowingAccountsMenu && (
        <>
          <nav className={accountsMenuStyles}>
            <MenuList menuItems={accountMenuItems} />
          </nav>
        </>
      )}
    </div>
  );
};
